import Home from "./Routes/HomePage/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./Routes/Dashboard/Dashboard";
import CreateEvent from "./Routes/CreateEvent/CreateEvent";
const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home></Home>} />
          <Route path="/Dashboard" element={<Dashboard></Dashboard>} />
          <Route path="/CreateEvent" element={<CreateEvent></CreateEvent>} />
        </Routes>
      </Router>
    </>
  );
};
export default App;
